/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:47
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-29 12:32:56
 * @FilePath: \hlweb2.0\src\pages\General\components\Particulars.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by Wang.Qiong on 2021/9/11.
 */
import React, { useState, useEffect } from 'react'
import { Modal, Input, Button, Table, message, Empty, Form } from 'antd';
import { getQiNiuToken } from '../../../utils/api'
const { TextArea } = Input;
function Particulars(props) {
    useEffect(() => {
        // console.log('**************');
        // console.log(props.particularsContent);

    }, [props])
    return (
        <div>
            <Modal
                className='changeNew'
                title="详情"
                centered
                visible={props.particularsVisible}
                onCancel={() => props.handleParticularsVisible(false)}
                width={900}
                height={400}
                footer={[
                    <Button onClick={() => props.handleParticularsVisible(false)} style={{ background: '#0093D8', color: '#fff' }}>
                        取消
                    </Button>
                ]}
            >
                <div>类型：{props.particularsContent?.moduleType}</div>
                <div>分类：{props.particularsContent?.codeBak}</div>
                <h1>{props.particularsContent?.title}</h1>
                <h4 style={{ padding: '20px 0px' }}>{props.particularsContent?.subtitle}</h4>
                <div className='new_content' dangerouslySetInnerHTML={{ __html: props.particularsContent?.context }}></div>
            </Modal>

        </div>
    )

}
export default Particulars;
